module.exports = __webpack_public_path__ + "img/科研团队标题.bb1894b0.png";